import { Injectable } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { UserService } from './user.service';
import { Subscription } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class AlertsService {
	// See app.module.ts for global ToastrService config

	private userEventSubscription!: Subscription;

	// EventEmitter used to replace AngularJS $broadcast (eg. $rootScope.$broadcast()), 'notifyDeleteAlert'
	notifyDeleteAlertEvent: EventEmitter<{ timestamp: Date }> = new EventEmitter();
	addAlertEvent: EventEmitter<{ alert: any; timestamp: Date }> = new EventEmitter();

	LOCALIZATION: any;

	constructor(
		private toastr: ToastrService,
		private userService: UserService
	) {
		this.userEventSubscription = this.userService.broadcastEvent.subscribe((event: string) => {
			if (event === 'localizationLoaded') {
				this.LOCALIZATION = this.userService.LOCALIZATION;
			}
		});
	}

	getAlerts(username: string): any[] {
		const storage = sessionStorage.getItem('alerts') ? JSON.parse(sessionStorage.getItem('alerts')!) : [];
		return storage.filter((alert: { user: string }) => alert.user === username);
	}

	addAlert(alert: any): any[] | undefined {
		if (!alert) {
			return;
		}

		if (this.userService.user.username && this.userService.user.username === alert.user) {
			alert.show = false;

			let useralerts = this.getAlerts(this.userService.user.username ?? '') || [];
			useralerts.unshift(alert);
			sessionStorage.setItem('alerts', JSON.stringify(useralerts));

			return useralerts;
		}

		return undefined;
	}

	removeAlert(index: number): any[] {
		let useralerts = this.getAlerts(this.userService.user.username ?? '') || [];
		useralerts.splice(index, 1);
		sessionStorage.setItem('alerts', JSON.stringify(useralerts));

		this.notifyDeleteAlertEvent.emit({
			timestamp: new Date(),
		});

		return useralerts;
	}

	removeAllAlerts(): void {
		sessionStorage.setItem('alerts', JSON.stringify([]));
	}

	clear(): void {
		this.toastr.clear();
	}

	success(alertData: any = {}): void {
		var alertData = (alertData) || ({});
		let date = new Date();
		let alert = {
			timeOut: alertData.delay || 3000,
			title: alertData.title || this.LOCALIZATION.success,
			message: alertData.message || "",
			user: this.userService.user.username,
			date: date.toLocaleString(),
			action: '',
			status: "success"
		};

		let alert1 = { ...alert };
		if (!alertData.nobroadcast) {
			this.addAlertEvent.emit({
				alert: alert1,
				timestamp: new Date(),
			});
		}
		this.notify('success', alert);
	}

	error(alertData: any = {}): void {
		var alertData = (alertData) || ({});
		let date = new Date();
		let alert = {
			timeOut: alertData.delay || 3000,
			title: alertData.title || this.LOCALIZATION.error,
			message: alertData.message || "",
			user: this.userService.user.username,
			date: date.toLocaleString(),
			status: "danger"
		};

		let alert1 = { ...alert };
		if (!alertData.nobroadcast) {
			this.addAlertEvent.emit({
				alert: alert1,
				timestamp: new Date(),
			});
		}
		this.notify('error', alert);
	}

	info(alertData: any = {}): void {
		var alertData = (alertData) || ({});
		let date = new Date();
		let alert = {
			timeOut: alertData.delay || 3000,
			title: alertData.title || this.LOCALIZATION.information,
			message: alertData.message || "",
			user: this.userService.user.username,
			date: date.toLocaleString(),
			status: "info"
		};

		let alert1 = { ...alert };
		if (!alertData.nobroadcast) {
			this.addAlertEvent.emit({
				alert: alert1,
				timestamp: new Date(),
			});
		}
		this.notify('info', alert);
	}

	notify(type: string, alert: any): void {
		if ('success' == type) {
			this.toastr.success(alert.message, alert.title, alert);
		} else if ('error' == type) {
			this.toastr.error(alert.message, alert.title, alert);
		} else {
			this.toastr.info(alert.message, alert.title, alert);
		}
	}
}
